<template>
  <div class="iot-layout">
    <home-nav-bar :title="$route.meta.title" />
    <div class="nav-bar">
      <router-link v-for="i in navOption" :key="i.name" :to="i.to" custom class="item">
        <template #default="{ href, route, navigate, isActive, isExactActive }">
          <a @click="navigate">
            <img :src="isActive?i.activeIcon:i.icon" alt="" class="icon">
            <div :class="{active:isActive}" class="name">
              {{ i.name }}
            </div>
          </a>
        </template>
      </router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
import HomeNavBar from '@/views/layout/components/HomeNavBar'

export default {
  name: 'Index',
  components: { HomeNavBar },
  data() {
    return {
      navOption: [
        {
          name: '溯源监控',
          icon: require('./images/camera.png'),
          activeIcon: require('./images/camera-active.png'),
          to: { name: 'IotCamera' }
        },
        {
          name: '环境检测',
          icon: require('./images/sensor.png'),
          activeIcon: require('./images/sensor-active.png'),
          to: { name: 'IotSensor' }
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.iot-layout {
  > .nav-bar {
    position: sticky;
    top: 46px;
    display: grid;
    grid-template-columns: repeat(2, 50%);
    text-align: center;
    background: #fff;
    font-size: 12px;
    font-weight: 500;
    color: #767676;
    height: 50px;
    align-items: center;
    z-index: 1;
    .icon {
      display: block;
      margin: 0 auto 2px;
      width: 24px;
      height: 24px;
      object-fit: cover;
    }
  }
}
</style>
